export default {
	GET_QUOTE: 'GET_QUOTE',
};
